<script module lang="ts">
  import type { Snippet } from "svelte";
  import type { SystemStyleObject } from "@agapi/ui/panda/types";

  export interface LanguagePickerContentProps {
    css?: SystemStyleObject;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { PopoverPositioner, PopoverContent} from "@agapi/ui/popover";
  import { languagePickerStyles } from "./language-picker.styles";

  const classes = languagePickerStyles.raw();
  const { children, css: cssProp }: LanguagePickerContentProps = $props();
</script>

<PopoverPositioner>
  <PopoverContent
    css={{
      ...classes.content,
      ...cssProp,
    }}
  >
    {@render children?.()}
  </PopoverContent>
</PopoverPositioner>
